<template>
    <div class="bordasuperior">
        <img class="logo" src="@/assets/icone_logo.png" alt="Logo">
    </div>   
</template>